import { debounce } from '@/heplers/index';
import { createIntersectionObserver } from '@/heplers/intersectionObserver';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames } from '@/templates/DataNames';

let codeExamplesObserver: IntersectionObserver;

export const createCodeExamplesObserver = (cb: (el: IntersectionObserverEntry) => void) => {
  destroyCodeExamplesObserver();
  const options: IntersectionObserverInit = {
    threshold: 0.05,
    rootMargin: '-10% 0px -50% 0px',
  };
  const debouncedCb = debounce(cb, 100);
  codeExamplesObserver = createIntersectionObserver(debouncedCb, { options });
  GlobalBus.emit(GlobalBusNames.CREATE_CODE_EXAMPLES_OBSERVER);
};

export const destroyCodeExamplesObserver = () => {
  codeExamplesObserver?.disconnect();
  codeExamplesObserver = undefined;
};

export const observeCodeExample = (el: Element) => {
  codeExamplesObserver?.observe(el);
};

export const unobserveCodeExample = (el: Element) => {
  codeExamplesObserver?.unobserve(el);
};
